import  { useState } from 'react';
import '../App.css';

const Contact = () => {
  const [status, setStatus] = useState(""); 

  const handleSubmit = async (e) => {
    e.preventDefault(); 

    const form = e.target;
    const data = new FormData(form);

    try {
      const response = await fetch("https://formspree.io/f/xblapbzv", {
        method: "POST",
        body: data,
        headers: {
          Accept: "application/json",
        },
      });

      if (response.ok) {
        setStatus("Merci ! Votre message a été envoyé ✅");
        form.reset();
      } else {
        setStatus("Oups... Une erreur est survenue ❌");
      }
    } catch (error) {
      setStatus("Erreur réseau, veuillez réessayer ❌");
    }
  };

  return (
    <footer className="contact-footer">
      <div className="contact-wrapper">
        <div className="form-container">
          <h3>Contactez-nous</h3>
          <form onSubmit={handleSubmit}>
            <label htmlFor="name">Nom</label>
            <input type="text" id="name" name="name" required />

            <label htmlFor="email">Email</label>
            <input type="email" id="email" name="email" required />

            <label htmlFor="message">Message</label>
            <textarea id="message" name="message" required></textarea>

            <button type="submit">Envoyer</button>
          </form>

          {status && <p style={{ marginTop: "1rem", color: "white" }}>{status}</p>}
        </div>
      </div>
    </footer>
  );
};

export default Contact;
